module.exports = __webpack_public_path__ + "img/fi-toasts.5518feb6.jpg";